<script lang="ts">
    import Cropper from "svelte-easy-crop";
    import {Avatar, Button, Fileupload, Heading} from "flowbite-svelte";
    import getCroppedImg from "$lib/utils/canvasUtils.js";

    export let previewFormat = 'avatar'
    export let name = 'avatar';

    let files: FileList;
    let image: string;
    let crop = {x: 0, y: 0};
    let zoom = 1;
    let croppedImage: Blob;
    let preview: string;

    function onFileSelected() {
        // 1 MB
        if (files[0].size > 1048576) {
            alert('Die Datei ist zu groß!');
            return;
        }
        let reader = new FileReader();
        reader.onload = e => {
            image = e.target.result;
        };
        reader.readAsDataURL(files[0]);
    }

    async function saveCroppedFile(e: CustomEvent<{
        pixels: { x: number, y: number, width: number, height: number }
    }>) {
        croppedImage = await getCroppedImg(image, e.detail.pixels);
        preview = URL.createObjectURL(croppedImage)
        // Convert Blob into File
        const file = new File([croppedImage], 'image.jpg', {type: croppedImage.type});
        // Create a new DataTransfer instance
        const dataTransfer = new DataTransfer();
        // Add file to DataTransfer
        dataTransfer.items.add(file);
        files = dataTransfer.files;
    }

</script>

<div class="flex gap-2">
    <Fileupload bind:files accept="image/*" {name}/>
    <Button type="button"
            on:click={() => {
                onFileSelected()
            }}>Zuschneiden
    </Button>
</div>

{#if image}
    <div class="relative w-full h-80">
        <Cropper
                {image}
                bind:crop
                bind:zoom
                on:cropcomplete={saveCroppedFile}
                aspect={1}
        />
    </div>
    <Heading tag="h3" class="text-neutral-600 font-lg">Vorschau</Heading>
    <div class="grid place-items-center">
        {#if previewFormat === 'avatar'}
            <Avatar size="xl" src={preview}/>
        {:else}
            <Avatar size="xl" rounded src={preview}/>
        {/if}
    </div>
    <div class="grid place-items-end">
        <Button type="submit">Übernehmen</Button>
    </div>
{/if}
